import { Popper } from "#lib/components/ui/popper/index"
import Content from "./TooltipContent.svelte"
import Portal from "./TooltipPortal.svelte"
import Provider from "./TooltipProvider.svelte"
import Root from "./TooltipRoot.svelte"
import Trigger from "./TooltipTrigger.svelte"

export { type TooltipProviderProps } from "./TooltipProvider.svelte"

export type { TooltipRootProps } from "./TooltipRoot.svelte"

export type { TooltipTriggerProps } from "./TooltipTrigger.svelte"

export type { TooltipPortalProps } from "./TooltipPortal.svelte"

export type { TooltipContentProps } from "./TooltipContent.svelte"

export const Tooltip = {
  Provider,
  Root,
  Trigger,
  Portal,
  Content,
  Arrow: Popper.Arrow,
}
